<div class="bc-page">
  <div class="bc-head">
    <h2>Builder Confirmations</h2>
    <div class="bc-sub" *ngIf="sessions.length">
      Sent {{ dayLabel(date) }}
      <span *ngIf="stats.scheduleDates?.length"> &middot; inspections
        <span *ngFor="let d of stats.scheduleDates; let last = last">{{ dayLabel(d) }}<span *ngIf="!last">, </span></span>
      </span>
    </div>
  </div>

  <div class="bc-controls">
    <label>Run date <input type="date" [(ngModel)]="date" (change)="load()"></label>
    <label class="bc-check"><input type="checkbox" [(ngModel)]="includeAll" (change)="load()"> Include manual/test</label>
    <button class="bc-btn" (click)="load()" [disabled]="loading">{{ loading ? 'Loading…' : 'Refresh' }}</button>
    <span class="bc-muted" *ngIf="updatedAt">Last updated {{ updatedAt | date:'h:mm a' }}</span>
  </div>

  <div class="bc-error" *ngIf="error">{{ error }}</div>
  <div class="bc-empty" *ngIf="!loading && !error && !sessions.length">No run that day.</div>

  <ng-container *ngIf="sessions.length">
    <div class="bc-tiles-label">Builders</div>
    <div class="bc-tiles">
      <div class="bc-tile"><div class="n">{{ stats.sent }}</div><div class="l">Texts sent</div></div>
      <div class="bc-tile" [class.warn]="stats.failed"><div class="n">{{ stats.failed }}</div><div class="l">Failed</div></div>
      <div class="bc-tile"><div class="n">{{ stats.opened }} <small>{{ stats.openedPct }}%</small></div><div class="l">Opened</div></div>
      <div class="bc-tile"><div class="n">{{ stats.some }} <small>{{ stats.somePct }}%</small></div><div class="l">Answered some</div></div>
      <div class="bc-tile"><div class="n">{{ stats.all }} <small>{{ stats.allPct }}%</small></div><div class="l">Answered all</div></div>
    </div>

    <div class="bc-tiles-label">Jobs</div>
    <div class="bc-tiles">
      <div class="bc-tile"><div class="n">{{ stats.jobs }}</div><div class="l">Jobs</div></div>
      <div class="bc-tile"><div class="n">{{ stats.confirmed }}</div><div class="l"><span class="dot st-ok"></span>Confirmed</div></div>
      <div class="bc-tile"><div class="n">{{ stats.callFirst }}</div><div class="l"><span class="dot st-call"></span>Call first</div></div>
      <div class="bc-tile"><div class="n">{{ stats.resched }}</div><div class="l"><span class="dot st-resched"></span>Reschedule</div></div>
      <div class="bc-tile" [class.warn]="stats.none"><div class="n">{{ stats.none }}</div><div class="l"><span class="dot st-none"></span>No response</div></div>
    </div>

    <div class="bc-filters">
      <input class="bc-search" type="text" placeholder="Search builder, phone, job, address…" [(ngModel)]="search">
      <button *ngFor="let f of filters" class="bc-chip" [class.on]="filter === f.key" (click)="filter = f.key">{{ f.label }}</button>
      <span class="bc-muted">{{ visible.length }} of {{ sessions.length }} builders</span>
      <span class="bc-spacer"></span>
      <button class="bc-btn bc-small" (click)="expandAll()">Expand all</button>
      <button class="bc-btn bc-small" (click)="collapseAll()">Collapse all</button>
    </div>

    <div class="bc-card" *ngFor="let s of visible" [class.open]="expanded.has(s.id)">
      <div class="bc-card-head" (click)="toggle(s)" role="button" [attr.aria-expanded]="expanded.has(s.id)">
        <span class="chev"></span>
        <div class="bc-who">
          <div class="bc-name">{{ s.contact_name || ('Contact ' + s.contact_id) }}
            <span class="bc-tag" *ngIf="s.created_by !== 'n8n'">{{ s.created_by }}</span>
          </div>
          <div class="bc-meta">
            {{ s.phone }}
            <span class="sep">&middot;</span>
            Text <span [class.ok]="isSent(s)" [class.bad]="isFailed(s)" [title]="s.sms_status">{{ textLabel(s) }}</span>
            <span class="sep">&middot;</span>
            {{ s.first_opened_at ? ('Opened ' + (s.first_opened_at | date:'h:mm a') + ' (' + s.open_count + '×)') : 'Not opened' }}
          </div>
        </div>
        <div class="bc-count" [class.done]="s.answered === s.jobs.length" [class.partial]="s.answered > 0 && s.answered < s.jobs.length">
          <span class="num">{{ s.answered }} / {{ s.jobs.length }}</span>
          <span class="lbl">answered</span>
        </div>
      </div>
      <table class="bc-table" *ngIf="expanded.has(s.id)">
        <thead>
          <tr><th>Job ID</th><th>Job</th><th>Subdivision-Lot</th><th>Address</th><th>Current status</th><th>Answered</th><th>History</th></tr>
        </thead>
        <tbody>
          <tr *ngFor="let j of s.jobs" [class.pending]="!j.conf_status">
            <td>{{ j.job_id }}</td>
            <td>{{ j.job_type }}</td>
            <td>{{ j.subdivision_lot }}</td>
            <td>{{ j.address }}</td>
            <td><span class="dot" [ngClass]="statusClass(j.conf_status)"></span>{{ j.conf_status || 'No response' }}</td>
            <td>
              <span *ngIf="j.answered_via === 'dashboard'">{{ j.answered_at | date:'h:mm a' }} (dashboard)</span>
              <span *ngIf="j.answered_via === 'email/staff'">(email/staff)</span>
              <span *ngIf="!j.answered_via">—</span>
            </td>
            <td>{{ j.history.length ? 'was: ' + j.history.join(' → ') : '—' }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </ng-container>
</div>
